import {
  withTranslation,
} from 'react-i18next';

import ChampionshipAdminRequestFieldsView from './ChampionshipAdminRequestFieldsView';

const TranslatedComponent = withTranslation()(ChampionshipAdminRequestFieldsView);

const Component = TranslatedComponent;

export default Component;
